<template>
  <v-container>
    <v-row>
      <v-col v-for="folder in visibleFolders" :key="folder.url" cols="12" md="6" lg="4" xl="3">

        <a v-if="folder.href" :href="folder.href ">
          <v-row no-gutters align="center">
            <v-col cols="3">
              <img :src="folder.img
                ? folder.img
                : $model.img_folder + '/blue-folder.png'
                " />
            </v-col>
            <v-col>
              {{ folder.controllerName }}
            </v-col>
          </v-row>
        </a>


        <router-link v-else :to="{ path: folder.url }">
          <v-row no-gutters align="center">
            <v-col cols="3">
              <img :src="folder.img
                ? folder.img
                : $model.img_folder + '/blue-folder.png'
                " />
            </v-col>
            <v-col>
              {{ folder.controllerName }}
            </v-col>
          </v-row>
        </router-link>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  props: {
    /**
     * {
     *  url:"url относительно блока",
     *  img:"path"
     * }
     */
    items: Array,
  },
  computed: {
    visibleFolders() {
      return this.items.filter((folder) => folder.visible);
    },
  },
};
</script>
